// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--ov5Kw";
export var middle = "footer-module--middle--nOIff";